// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  width: 250px;
  background-color: #f8f9fa;
  border-right: 1px solid #dee2e6;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  transition: width 0.3s ease;
}

.navigation.collapsed {
  width: 80px;
}

.nav-header {
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
  background-color: #ffffff;
}

.nav-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.nav-close-btn,
.nav-toggle-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  z-index: 1000;
}

.nav-close-btn {
  display: none;
}

.nav-toggle-btn {
  font-size: 20px;
  font-weight: bold;
}

.mobile-only {
  display: none;
}

.desktop-only {
  display: flex;
}

.nav-close-btn:hover,
.nav-toggle-btn:hover {
  background-color: #f1f3f4;
  color: #333;
}

.nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  display: none;
}

.nav-header h3 {
  margin: 0;
  color: #495057;
  font-size: 18px;
  font-weight: 600;
}

.user-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.user-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
}

.user-details {
  flex: 1 1;
  min-width: 0;
}

.user-name {
  font-weight: 600;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  font-size: 11px;
  color: #666;
  text-transform: capitalize;
}

.user-avatar-collapsed {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  margin: 0 auto;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1 1;
}

.nav-item {
  margin: 0;
}

.nav-button {
  width: 100%;
  padding: 15px 20px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #6c757d;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f3f4;
}

.navigation.collapsed .nav-button {
  padding: 15px 10px;
  justify-content: center;
  gap: 0;
}

.nav-button:hover {
  background-color: #e9ecef;
  color: #495057;
}

.nav-button.active {
  background-color: #007bff;
  color: white;
  font-weight: 500;
}

.nav-button.active:hover {
  background-color: #0056b3;
}

.nav-icon {
  font-size: 18px;
  width: 20px;
  text-align: center;
}

.nav-label {
  flex: 1 1;
}

.nav-footer {
  padding: 20px;
  border-top: 1px solid #dee2e6;
  background-color: #ffffff;
}

.logout-button {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #dc3545;
  background: white;
  color: #dc3545;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.navigation.collapsed .logout-button {
  padding: 12px 10px;
  justify-content: center;
  gap: 0;
}

.logout-button:hover {
  background-color: #dc3545;
  color: white;
}

/* Impersonation indicator styles */
.impersonation-indicator {
    background: #ff6b6b;
    color: white;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 2px solid #ff5252;
    text-align: center;
}

.impersonation-warning {
    font-weight: bold;
    font-size: 0.9em;
    margin-bottom: 5px;
}

.impersonation-admin {
    font-size: 0.8em;
    opacity: 0.9;
    margin-bottom: 8px;
}

.stop-impersonation-btn {
    background: #fff;
    color: #ff6b6b;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    font-size: 0.8em;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
}

.stop-impersonation-btn:hover {
    background: #f0f0f0;
}

.impersonation-indicator-collapsed {
    background: #ff6b6b;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px auto;
    cursor: pointer;
    font-size: 1.2em;
    border: 2px solid #ff5252;
    transition: background-color 0.3s;
}

.impersonation-indicator-collapsed:hover {
    background: #ff5252;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .navigation {
    width: 280px;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .navigation.mobile-open {
    transform: translateX(0);
  }
  
  .nav-overlay {
    display: block;
  }
  
  .mobile-only {
    display: flex !important;
  }
  
  .desktop-only {
    display: none !important;
  }
  
  /* Always show close button when navigation is open on mobile */
  .navigation.mobile-open .mobile-only {
    display: flex !important;
  }
  
  .nav-button {
    padding: 12px 15px;
    font-size: 13px;
  }
  
  .nav-header {
    padding: 15px;
  }
  
  .nav-header h3 {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,SAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,mCAAmC;AACnC;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,4BAA4B;IAC5B,+BAA+B;IAC/B,yCAAyC;EAC3C;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,+DAA+D;EAC/D;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".navigation {\n  width: 250px;\n  background-color: #f8f9fa;\n  border-right: 1px solid #dee2e6;\n  height: 100vh;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  transition: width 0.3s ease;\n}\n\n.navigation.collapsed {\n  width: 80px;\n}\n\n.nav-header {\n  padding: 20px;\n  border-bottom: 1px solid #dee2e6;\n  background-color: #ffffff;\n}\n\n.nav-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.nav-close-btn,\n.nav-toggle-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #666;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n  z-index: 1000;\n}\n\n.nav-close-btn {\n  display: none;\n}\n\n.nav-toggle-btn {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.mobile-only {\n  display: none;\n}\n\n.desktop-only {\n  display: flex;\n}\n\n.nav-close-btn:hover,\n.nav-toggle-btn:hover {\n  background-color: #f1f3f4;\n  color: #333;\n}\n\n.nav-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 99;\n  display: none;\n}\n\n.nav-header h3 {\n  margin: 0;\n  color: #495057;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.user-badge {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.user-avatar {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.user-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-name {\n  font-weight: 600;\n  font-size: 13px;\n  color: #333;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-role {\n  font-size: 11px;\n  color: #666;\n  text-transform: capitalize;\n}\n\n.user-avatar-collapsed {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  margin: 0 auto;\n}\n\n.nav-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  flex: 1;\n}\n\n.nav-item {\n  margin: 0;\n}\n\n.nav-button {\n  width: 100%;\n  padding: 15px 20px;\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: #6c757d;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f1f3f4;\n}\n\n.navigation.collapsed .nav-button {\n  padding: 15px 10px;\n  justify-content: center;\n  gap: 0;\n}\n\n.nav-button:hover {\n  background-color: #e9ecef;\n  color: #495057;\n}\n\n.nav-button.active {\n  background-color: #007bff;\n  color: white;\n  font-weight: 500;\n}\n\n.nav-button.active:hover {\n  background-color: #0056b3;\n}\n\n.nav-icon {\n  font-size: 18px;\n  width: 20px;\n  text-align: center;\n}\n\n.nav-label {\n  flex: 1;\n}\n\n.nav-footer {\n  padding: 20px;\n  border-top: 1px solid #dee2e6;\n  background-color: #ffffff;\n}\n\n.logout-button {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid #dc3545;\n  background: white;\n  color: #dc3545;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.navigation.collapsed .logout-button {\n  padding: 12px 10px;\n  justify-content: center;\n  gap: 0;\n}\n\n.logout-button:hover {\n  background-color: #dc3545;\n  color: white;\n}\n\n/* Impersonation indicator styles */\n.impersonation-indicator {\n    background: #ff6b6b;\n    color: white;\n    padding: 10px;\n    margin: 10px 0;\n    border-radius: 5px;\n    border: 2px solid #ff5252;\n    text-align: center;\n}\n\n.impersonation-warning {\n    font-weight: bold;\n    font-size: 0.9em;\n    margin-bottom: 5px;\n}\n\n.impersonation-admin {\n    font-size: 0.8em;\n    opacity: 0.9;\n    margin-bottom: 8px;\n}\n\n.stop-impersonation-btn {\n    background: #fff;\n    color: #ff6b6b;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 3px;\n    font-size: 0.8em;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.stop-impersonation-btn:hover {\n    background: #f0f0f0;\n}\n\n.impersonation-indicator-collapsed {\n    background: #ff6b6b;\n    color: white;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 10px auto;\n    cursor: pointer;\n    font-size: 1.2em;\n    border: 2px solid #ff5252;\n    transition: background-color 0.3s;\n}\n\n.impersonation-indicator-collapsed:hover {\n    background: #ff5252;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .navigation {\n    width: 280px;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  .navigation.mobile-open {\n    transform: translateX(0);\n  }\n  \n  .nav-overlay {\n    display: block;\n  }\n  \n  .mobile-only {\n    display: flex !important;\n  }\n  \n  .desktop-only {\n    display: none !important;\n  }\n  \n  /* Always show close button when navigation is open on mobile */\n  .navigation.mobile-open .mobile-only {\n    display: flex !important;\n  }\n  \n  .nav-button {\n    padding: 12px 15px;\n    font-size: 13px;\n  }\n  \n  .nav-header {\n    padding: 15px;\n  }\n  \n  .nav-header h3 {\n    font-size: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
